import type { NotificationThread } from '../../lib/threading'
import { urgencyOfRow, type NotificationDay } from '../../lib/days'
import { MINE_LENS_KINDS } from '../../lib/lens-kinds'

/**
 * The four readings of the same history, and the filtering behind them.
 *
 * Split out of the centre because the lenses are pressed on the navbar row and
 * applied in the centre's body, and those are two files now. Nothing here is a
 * catalogue a broker would ever want to add to: these are the four relations a
 * notification can have to the person reading it, not a list of categories.
 */

export type Lens = 'all' | 'needs' | 'mine' | 'firm'

export const LENSES: readonly { value: Lens; label: string }[] = [
  { value: 'all', label: 'Everything' },
  { value: 'needs', label: 'Needs me' },
  { value: 'mine', label: 'Addressed to me' },
  { value: 'firm', label: 'The firm' },
]

/**
 * The same list the badge scope sends the server, read from `lib/` rather than
 * declared twice: the lens COUNT is taken over the set and the lens FILTER is
 * applied here, so the two would drift the moment a kind was added to one.
 */
const MINE: ReadonlySet<string> = new Set(MINE_LENS_KINDS)

export const keeps = (lens: Lens) => (t: NotificationThread): boolean => {
  if (lens === 'all') return true
  if (lens === 'firm') return t.head.clientId === null
  if (lens === 'mine') return MINE.has(t.head.kind)
  const u = urgencyOfRow(t.head)
  return u === 'now' || u === 'today'
}

export const filterDay = (day: NotificationDay, lens: Lens): NotificationDay => {
  const threads = day.threads.filter(keeps(lens))
  return {
    ...day,
    threads,
    count: threads.reduce((sum, t) => sum + t.count, 0),
    unreadCount: threads.reduce((sum, t) => sum + t.unreadCount, 0),
  }
}
